import _toConsumableArray from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import classnames from 'classnames';
import Checkbox from '../Checkbox';
import { PureComponent } from '../component';
import { transferClass } from './styles';
import Context from './context';

var Item =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Item, _PureComponent);

  var _super = _createSuper2(Item);

  function Item(props) {
    var _this;

    _classCallCheck(this, Item);

    _this = _super.call(this, props);
    _this.check = _this.check.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Item, [{
    key: "check",
    value: function check(c) {
      var _this$props = this.props,
          index = _this$props.index,
          selecteds = _this$props.selecteds,
          checkKey = _this$props.checkKey,
          setSelecteds = _this$props.setSelecteds;

      if (c) {
        setSelecteds(index, [].concat(_toConsumableArray(selecteds[index]), [checkKey]));
      } else {
        setSelecteds(index, selecteds[index].filter(function (ch) {
          return ch !== checkKey;
        }));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          content = _this$props2.content,
          selecteds = _this$props2.selecteds,
          checkKey = _this$props2.checkKey,
          index = _this$props2.index,
          disabled = _this$props2.disabled,
          itemClass = _this$props2.itemClass;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: classnames(transferClass('item', disabled && 'item-disabled'), itemClass)
        },
        /*#__PURE__*/
        React.createElement(Checkbox, {
          className: transferClass('item-check'),
          onChange: this.check,
          disabled: disabled,
          checked: selecteds[index].indexOf(checkKey) > -1
        }, content))
      );
    }
  }]);

  return Item;
}(PureComponent);

export default (function (prop) {
  return (
    /*#__PURE__*/
    React.createElement(Context.Consumer, null, function (value) {
      return (
        /*#__PURE__*/
        React.createElement(Item, Object.assign({}, prop, {
          selecteds: value.selecteds,
          setSelecteds: value.setSelecteds,
          itemClass: value.itemClass
        }))
      );
    })
  );
});